import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { common, error, formData, formSettings, payment, promocode, voucher } from '../../../../constants/actions'
import withColorSetting from '../../../../hoc/withColorSettings'
import {
  getCurrentRegistration,
  getDisplayPriceAsZero,
  getFeeConfigurations,
  getFormId,
  getFormSettings,
  getFormType,
  getOrganisationWithVoucherConfig,
  getPaymentGateways,
  getPromoCodeError,
  getPromoCodeValue,
  getSessionId,
  getUser,
  getUserId,
  getValidatedPromoCodes,
} from '../../../../selectors'
import SummaryComponent from './component'

const mapStateToProps = state => ({
  organisation: getOrganisationWithVoucherConfig(state),
  organisationsInfo: get(state, 'formInfo.organisationsInfo'),
  formQuestions: get(state, 'formInfo.questions'),
  products: get(state, 'formInfo.products'),
  productGroups: get(state, 'formInfo.productGroups'),
  subEvents: get(state, 'formInfo.subEvents'),
  addOn: get(state, 'formInfo.addOn'),
  registrations: get(state, 'formData.registrations'),
  summaryPageError: get(state, 'error.summaryPageError'),
  voucherDataOnLoad: get(state, 'voucher'),
  userId: getUserId(state),
  user: getUser(state),
  form: getFormId(state),
  formType: getFormType(state),
  voucherSessionId: get(state, 'voucher.sessionId'),
  paymentGateway: getPaymentGateways(state),
  feeConfigurations: getFeeConfigurations(state),
  paymentMethod: get(state, 'payment.paymentMethod'),
  startTimer: get(state, 'common.startTimer'),
  currentRegistration: getCurrentRegistration(state),
  discounts: get(state, 'formInfo.discounts'),
  promoCodeValue: getPromoCodeValue(state),
  promoCodeError: getPromoCodeError(state),
  validatedPromoCodes: getValidatedPromoCodes(state),
  team: get(state, 'formInfo.team'),
  isTeamEvent: get(state, 'formInfo.event.isTeamEvent'),
  registeredTeam: get(state, 'formData.team'),
  formSettings: getFormSettings(state),
  displayPriceAsZero: getDisplayPriceAsZero(state),
  sessionId: getSessionId(state),
})

export default withRouter(
  connect(mapStateToProps, {
    removeMember: formData.removeMember,
    removeMemberItems: formData.removeMemberItems,
    setCurrentRegistration: formData.setCurrentRegistration,
    validateSessions: formData.validateSessions,
    submitRegistrations: formData.submitRegistrations,
    setPaymentData: payment.setPaymentData,
    onSummaryPageError: error.onSummaryPageError,
    resetTimer: common.resetTimer,
    setStartTimer: common.setStartTimer,
    setSessionId: formData.setSessionId,
    setPaymentMethod: payment.setPaymentMethod,
    validateVoucher: voucher.validateVoucher,
    validateVoucherBeforeProceed: voucher.validateVoucherBeforeProceed,
    removeVoucher: voucher.removeVoucher,
    validateVoucherSession: voucher.validateVoucherSession,
    initVoucherSession: voucher.initSession,
    updateVoucherData: voucher.updateVoucherData,
    removeVoucherData: voucher.removeVoucherData,
    setPromoCodeValue: promocode.setPromoCodeValue,
    initPromoCodeSession: promocode.initPromoCodeSession,
    addPromoCode: promocode.addPromoCode,
    removePromoCode: promocode.removePromoCode,
    removeTeam: formData.removeTeam,
    removeTeamItems: formData.removeTeamItems,
    resetInsurance: formSettings.resetInsurance,
  })(withColorSetting(SummaryComponent))
)
